import axios from "axios"
import { LANDING_PAGES_URL } from "src/constants"

export const updateLandingPageUrl = async (urlId, landingPageUrl) => {
   return await axios.patch(`${LANDING_PAGES_URL}/${urlId}`, {
      url: landingPageUrl,
   })
}
